import api from "@/api";
export default {
  install: function install(Vue) {
    Vue.prototype.$api = api;
  }
};